import { render, staticRenderFns } from "./panel.vue?vue&type=template&id=73702e93&scoped=true&"
import script from "./panel.vue?vue&type=script&lang=js&"
export * from "./panel.vue?vue&type=script&lang=js&"
import style0 from "./panel.vue?vue&type=style&index=0&id=73702e93&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73702e93",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PromotionTournamentPodiumRow: require('/var/web/bet777.es/components/promotion-tournament/podium-row.vue').default,PromotionTournamentRankingRow: require('/var/web/bet777.es/components/promotion-tournament/ranking-row.vue').default,PromotionTournamentBottomMenu: require('/var/web/bet777.es/components/promotion-tournament/bottom-menu.vue').default})
